import React from "react";
import { Image } from "react-bootstrap";

function MegaMenuCategoryList({ setHeadClass, blogData, categoryType, categoryTypeClassName, setOpenMegaMenu, setActiveClass, setOldClass, isOdd, setisOdd }) {
  return (
    <li
      className={`col menuBlock ${categoryTypeClassName}`}
      onMouseEnter={() => {
        setActiveClass(categoryType);
        setHeadClass(categoryType);
        setisOdd(!isOdd);
      }}
      onMouseLeave={() => {
        setOldClass(categoryType);
        setHeadClass("");
      }}
    >
      <a onClick={() => setOpenMegaMenu(true)} href={`/blog/${blogData?.slug}`}>
        <p className="fw-bold text-xl">{blogData?.type}</p>
      </a>
      <ul>
        {blogData?.sub_type?.map((item) => {
          return (
            <li className="text-nowrap text-lg" key={item?.id}>
              <a href={`/blog/${blogData?.slug}/${item?.slug}`} onClick={() => setOpenMegaMenu(true)}>
                <Image alt={`${item?.name} icon`} src={item?.image || ""} width={20} height={20} className="mr-2" />
                <span>{item?.name}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </li>
  );
}
export default MegaMenuCategoryList;
